import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { FallingLines } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { socket } from "../../App";
import ClipIcon from "../../assets/svg/ClipIcon.svg";
import SendIcon from "../../assets/svg/SendIcon.svg";
import SmileyIcon from "../../assets/svg/SmileyIcon.svg";
import ThreeDotIcon from "../../assets/svg/ThreeDotIcon.svg";
import styles from "./Chat.module.scss";
import EmojiPicker from "emoji-picker-react";
import Avatar from "../../components/Avatar/Avatar";
import axios from "../../components/Hooks/axios";
import { FaArrowLeftLong } from "react-icons/fa6";

// export const socket = io(`${process.env.REACT_APP_BASE_API_URL}/socket_connection`);

const ActiveChat = ({ ActiveChatId, onBack }) => {
  const { userId, user } = useSelector((state) => state.auth);
  const [Popup, setPopup] = useState(false);
  const [InputText, setInputText] = useState("");
  const [FileSelected, setFileSelected] = useState(null);
  const fileRef = useRef();
  const chatContainerRef = useRef();
  const [chat, setChat] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [onlineStatus, setOnlineStatus] = useState(false);
  const [openEmoji, setOpenEmoji] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const [reportModal, setReportModal] = useState(false);
  const [reason, setReason] = useState("");

  const [blockModal, setBlockModal] = useState(false);
  const [blockreason, setBlockReason] = useState("");

  useEffect(() => {
    const domNode = chatContainerRef.current;
    domNode.scrollTop = domNode.scrollHeight;
  }, [chat]);

  useEffect(() => {
    setIsLoading(true);
    socket.emit("joinRoom", ActiveChatId.data._id);
    socket.on("chatHistory", (payload) => {
      setIsLoading(false);
      setChat(payload);
    });
    return () => socket.emit("leaveRoom", ActiveChatId.data._id);
  }, [ActiveChatId]);

  useEffect(() => {
    const handleMessage = (payload) => {
      console.log("MESSAGE RECEIVED:", payload);
      setChat((prev) => [...prev, payload]);
    };

    const roomId = ActiveChatId.data._id;

    socket.on(`message_${roomId}`, handleMessage);
    socket.on(`receive_message_${roomId}`, handleMessage);

    return () => {
      socket.off(`message_${roomId}`, handleMessage);
      socket.off(`receive_message_${roomId}`, handleMessage);
    };
  }, [ActiveChatId]);

  useEffect(() => {
    if (!userId || !socket || !ActiveChatId) return;

    if (user && user.is_active === true) {
      socket.emit("joinLoginRoom", { userId });
    } else {
      socket.emit("joinLoginRoom", { userId, activeStatus: false });
    }

    const handleUserOnline = (payload) => {
      const activeMatch = payload.find(
        (item) => item.userId === ActiveChatId.userData._id,
      );
      if (activeMatch?.userId) setOnlineStatus(true);
      else setOnlineStatus(false);
    };

    socket.on("userOnline", handleUserOnline);

    return () => {
      socket.off("userOnline", handleUserOnline);
    };
  }, [socket, userId, user, ActiveChatId]);

  const handelSentBtn = async () => {
    if (InputText.trim() === "" && !FileSelected) return;

    setIsUploading(true);
    let attachmentUrl = "";
    let attachmentType = "";

    try {
      if (FileSelected) {
        const formData = new FormData();
        formData.append("files", FileSelected); // backend expects 'files'
        formData.append("path", "chat");

        const response = await axios.post("/multipleFileUpload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.data && !response.data.error) {
          attachmentUrl = response.data.Data[0].Location;
          attachmentType = FileSelected.type.startsWith("image")
            ? "image"
            : "video";
        } else {
          console.error("Upload failed", response.data);
          setIsUploading(false);
          return;
        }
      }

      let data = {
        room: ActiveChatId.data._id,
        sender: userId,
        message: InputText,
        attachment: attachmentUrl,
        attachmentType: attachmentType,
      };

      socket.emit("chatMessage", data);
      setInputText("");
      setFileSelected(null);
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleBlock = async () => {
    setPopup(false);
    setBlockModal(true);
    setBlockReason("");
    if (!blockreason) return;

    try {
      const { data } = await axios.post("/auth/block-unblock-user", {
        user_id: ActiveChatId.userData._id,
        type: "block",
      });
      if (data.success) {
        toast.success("User blocked successfully");
        setPopup(false);
        setBlockModal(false);
      }
    } catch (error) {
      console.error("Error blocking user:", error);
      toast.error(error.response?.data?.message || "Error blocking user");
      setPopup(false);
      setBlockModal(false);
    }
  };

  const handleReport = async () => {
    // const reason = prompt("Please enter a reason for reporting this user:");
    setPopup(false);
    setReportModal(true);
    setReason("");
    if (!reason) return;

    try {
      const { data } = await axios.post("/auth/report-user", {
        reported_user_id: ActiveChatId.userData._id,
        reason: reason,
        description: "Reported from chat menu",
      });
      if (data.success) {
        toast.success("User reported successfully");
        setPopup(false);
        setReportModal(false);
      }
    } catch (error) {
      console.error("Error reporting user:", error);
      toast.error("Error reporting user");
    }
  };

  let messageDate2 = "";
  let todayCheck2 = false;

  return (
    <div className={styles.ActiveChatContainer}>
      <div className={styles.ActiveChatProfileContainer}>
        <div className={styles.ActiveChatProfileLeft}>
          {onBack && (
            <button
              className={styles.BackIcon}
              onClick={onBack}
              style={{
                all: "unset",
                cursor: "pointer",
                marginRight: "1.5rem",
                display: "flex",
                alignItems: "center",
              }}
            >
              <FaArrowLeftLong style={{ fontSize: "2.4rem", color: "#444" }} />
            </button>
          )}
          <div className={styles.ActiveChatProfileImage}>
            <Avatar
              src={ActiveChatId?.userData?.ProfilePic}
              name={ActiveChatId?.userData?.username}
            />
          </div>
          <div>
            <h1>{ActiveChatId?.userData?.username}</h1>
            {onlineStatus ? <h6>Online</h6> : <h5>Offline</h5>}
          </div>
        </div>
        <img
          src={ThreeDotIcon}
          alt="ThreeDotIcon"
          style={{ cursor: "pointer", padding: ".5rem 1rem", width: "2.7rem" }}
          onClick={() => setPopup(!Popup)}
        />
      </div>

      {/* report-user Modal */}

      <div
        className={`${reportModal ? styles.ReportUserModal : styles.ReportUserModalDisplayNone}`}
      >
        <div
          className={`${reportModal ? styles.reportBox : styles.reportBoxDisplayNone}`}
        >
          <h2>Report User</h2>
          <textarea
            placeholder="Please enter a reason for reporting this user..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          <div className={styles.reportButtons}>
            <button onClick={handleReport} disabled={!reason.trim()}>
              Submit Report
            </button>
            <button onClick={() => setReportModal(false)}>Cancel</button>
          </div>
        </div>
      </div>

      {/* block-user Modal */}

      <div
        className={`${blockModal ? styles.BlockUserModal : styles.BlockUserModalDisplayNone}`}
      >
        <div
          className={`${blockModal ? styles.blockBox : styles.blockBoxDisplayNone}`}
        >
          <h2>Block User</h2>
          <textarea
            placeholder="Please enter a reason for block this user..."
            value={blockreason}
            onChange={(e) => setBlockReason(e.target.value)}
          />
          <div className={styles.blockButtons}>
            <button onClick={handleBlock} disabled={!blockreason.trim()}>
              Block User
            </button>
            <button onClick={() => setBlockModal(false)}>Cancel</button>
          </div>
        </div>
      </div>

      <div
        className={`${styles.ThreeDotPopupContainer} ${Popup && styles.ActiveThreeDotPopup}`}
        onClick={() => setPopup(false)}
      >
        <div
          className={styles.ThreeDotButtonContainer}
          onClick={(e) => e.stopPropagation()}
        >
          <button type="button" onClick={handleReport}>
            Report User
          </button>
          <button type="button" onClick={handleBlock}>
            Block User
          </button>
        </div>
      </div>

      {/* Chat Container Start */}
      <div className={styles.ActiveChatSMSContainer} ref={chatContainerRef}>
        {isLoading ? (
          <div className={styles.loadingContainer}>
            <FallingLines
              color="#3A0DBB"
              width="100"
              visible={true}
              ariaLabel="falling-lines-loading"
            />
          </div>
        ) : (
          chat.map((data, index) => {
            const date = new Date(data.updatedAt);
            const time = `${date.toLocaleTimeString().split(":")[0]}:${date.toLocaleTimeString().split(":")[1]} ${
              date.toLocaleTimeString().split(" ")[1]
            }`;
            const messageDate =
              date.getDate() + "-" + date.getMonth() + "-" + date.getFullYear();
            let today = new Date();
            const yesterday =
              today.getDate() -
              1 +
              "-" +
              today.getMonth() +
              "-" +
              today.getFullYear();
            today =
              today.getDate() +
              "-" +
              today.getMonth() +
              "-" +
              today.getFullYear();
            const todayCheck = messageDate === today;
            const toadyPrint = todayCheck2 ? "" : "Today";
            todayCheck2 = todayCheck;
            const messageDateCheck = messageDate == messageDate2;
            messageDate2 = messageDate;

            return (
              <div key={index}>
                <h4>
                  {todayCheck
                    ? toadyPrint
                    : messageDateCheck
                      ? ""
                      : messageDate === yesterday
                        ? "Yesterday"
                        : messageDate}
                </h4>
                {data.sender === userId ? (
                  <div className={styles.ChatBoxMy}>
                    <div className={styles.MyChatBox}>
                      {data.attachment && (
                        <div className={styles.attachmentPreview}>
                          {data.attachmentType === "image" ? (
                            <img
                              src={data.attachment}
                              alt="attachment"
                              style={{
                                maxWidth: "200px",
                                borderRadius: "10px",
                              }}
                            />
                          ) : (
                            <video
                              src={data.attachment}
                              controls
                              style={{
                                maxWidth: "200px",
                                borderRadius: "10px",
                              }}
                            />
                          )}
                        </div>
                      )}
                      {data.text}
                      <span>{time}</span>
                    </div>
                  </div>
                ) : (
                  <div className={styles.ChatBoxYou}>
                    <div className={styles.YourChatBox}>
                      {data.attachment && (
                        <div className={styles.attachmentPreview}>
                          {data.attachmentType === "image" ? (
                            <img
                              src={data.attachment}
                              alt="attachment"
                              style={{
                                maxWidth: "200px",
                                borderRadius: "10px",
                              }}
                            />
                          ) : (
                            <video
                              src={data.attachment}
                              controls
                              style={{
                                maxWidth: "200px",
                                borderRadius: "10px",
                              }}
                            />
                          )}
                        </div>
                      )}
                      {data.text}
                      <span>{time}</span>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
      {/* Chat Container End */}

      <div className={styles.ActiveChatInputContainer}>
        <img
          src={SmileyIcon}
          alt="emoji"
          onClick={() => setOpenEmoji(!openEmoji)}
        />

        {openEmoji && (
          <div className={styles.EmojiContainer}>
            <EmojiPicker
              height="100%"
              width="100%"
              onEmojiClick={(e) =>
                setInputText((prevText) => prevText + e.emoji)
              }
              emojiStyle={"apple"}
            />
          </div>
        )}

        <img
          src={ClipIcon}
          alt="clip"
          onClick={() => fileRef.current.click()}
        />

        <input
          type="file"
          ref={fileRef}
          style={{ display: "none" }}
          onChange={(e) => {
            let file = e.target.files[0];
            setFileSelected(file);
            e.target.value = null;
          }}
        />

        <div className={styles.ChatInputWrapper}>
          {FileSelected && (
            <div className={styles.fileSelectedPreview}>
              <span>📎 {FileSelected.name}</span>
              <button onClick={() => setFileSelected(null)}>✕</button>
            </div>
          )}
          <input
            type="text"
            placeholder="Type something "
            value={InputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handelSentBtn();
            }}
            disabled={isUploading}
          />
        </div>

        <button
          type="button"
          className={styles.SendButton}
          onClick={handelSentBtn}
          disabled={isUploading}
        >
          {isUploading ? (
            <FallingLines color="#fff" width="25" visible={true} />
          ) : (
            <img src={SendIcon} alt="SendIcon" />
          )}
        </button>
      </div>
    </div>
  );
};

export default ActiveChat;
